import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { getSlugFromPath, detectBrowserSlug, slugToLocale } from './locale-utils';

// Resolve the active language synchronously from the URL slug (falling back to
// browser detection) so i18next loads the correct locale on first render. Without
// this it inits to fallbackLng (en_US) and only swaps after mount → English flash.
function getInitialLanguage(): string {
  const slug = getSlugFromPath(window.location.pathname) ?? detectBrowserSlug();
  return slugToLocale[slug];
}

export const supportedLanguages = [
  'en_US', 'zh_TW', 'zh_CN',
  'ja', 'ko', 'th', 'vi', 'id',
  'es', 'fr', 'de', 'pt', 'it', 'ru', 'tr', 'nl',
  'ar', 'hi', 'ms', 'pl',
] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en_US: 'English',
  zh_TW: '繁體中文',
  zh_CN: '简体中文',
  ja: '日本語',
  ko: '한국어',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  id: 'Bahasa Indonesia',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  pt: 'Português',
  it: 'Italiano',
  ru: 'Русский',
  tr: 'Türkçe',
  nl: 'Nederlands',
  ar: 'العربية',
  hi: 'हिन्दी',
  ms: 'Bahasa Melayu',
  pl: 'Polski',
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: 'en_US',
    lng: getInitialLanguage(),
    load: 'currentOnly',
    debug: import.meta.env.DEV,

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;
